import Image from 'next/image'
import {usePathname} from 'next/navigation'
import Link from 'next/link'
import useAuth from '@/hooks/useAuth'
import FooterDisclosure from './Footer/FooterDisclosure'
import {FooterLogo, PhoneIcon, EmailIcon, AddressIcon} from '@/utils/Icons'

interface Props {
  settings: any
  featured_categories: any
}
export default function Footer({settings, featured_categories}: Props) {
  const {user} = useAuth('none')

  const path = usePathname()

  const customerCareLinks = [
    { name: 'سلة المشتريات', href: '/cart' },
    ...(user
      ? [
          { name: 'الحساب الشخصي', href: '/account' },
          { name: 'العناوين', href: '/account/address' },
          { name: 'طلباتي', href: '/account/orders' },
          { name: 'الكتب المفضلة', href: '/account/wishlist' },
        ]
      : []),
  ]

  const generalLinks = [
    { name: 'الرئيسية', href: '/' },
    { name: 'اتصل بنا', href: '/contactus' },
    { name: 'من نحن', href: '/aboutus' },
    { name: 'شروط الأستخدام', href: '/policies' },
    { name: 'سياسة التوصيل', href: '/delivery_policy' },
  ]
  return (
    <footer className="bg-primary-700 text-white pt-[40px] pb-3 lg:pt-6">
      <div className="footer-container container-fluid">
        <div className="footer-about">
          <div className="footer-logo">
            {/* <Image src={LogoImage} alt="logo-img" className="w-36" /> */}
            <FooterLogo/>
          </div>
          <p className="mt-[24px] mb-[16px] lg:mb-0 lg:mt-2 font-light xl:max-w-[90%] 2xl:max-w-[80%]">
            {path == '/delivery_policy'
              ? `يمكنكم موقع "بصمتي" من ادراج اسماء اطفالكم الشخصية على جميع المنتوجات ,يمكنكم طلب قصة باسم طفلكم او طفلتكم حيث يكون هو بطل القصة , ويمكنكم طلب منتجات مثل الدفاتر واليوميات بالتصميم الذي تريدون بحيث يكون مطبوع مع اسم ابنكم او ابنتكم , كراسات تلوين وملصقات ,تجهيزات عيد الميلاد كلها مطبوعة باسم ابنكم , في الموقع تجدون ايضا منتجات للكبار حيث يمكنكم الموقع من اضافة اهداء او اسم شخصي على المنتج`
              : settings.about}
          </p>
        </div>

        {/* Categories for large devices */}
        <div className="hidden lg:block links mt-6">
          <h3 className="text-success font-semibold text-xl">التصنيفات</h3>
          <ul className="mt-4">
            {featured_categories?.map((category: any) => {
              return (
                <li key={category.id}>
                  <Link href={`/products?categories=${category.slug}`}>
                    {category.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
        
        {/* Categories for mobile devices */}
        {featured_categories && (
          <FooterDisclosure title="التصنيفات" links={featured_categories} />
        )}

        {/* Cutomer Care for large devices */}
        <div className="hidden lg:block links mt-6">
          <h3 className="text-success font-semibold text-xl">رعاية العملاء</h3>
          <ul className="mt-4">
            <li className=" mt-2">
              <Link href="/cart">سلة المشتريات </Link>
            </li>
            {user && (
              <>
                <li className=" mt-2">
                  <Link href="/account">الحساب الشخصي</Link>
                </li>
                <li className=" mt-2">
                  <Link href="/account/address">العناوين</Link>
                </li>
                <li className=" mt-2">
                  <Link href="/account/orders">طلباتي</Link>
                </li>
                <li className=" mt-2">
                  <Link href="/account/wishlist">الكتب المفضلة</Link>
                </li>
              </>
            )}
          </ul>
        </div>
        {/* Cutomer Care for mobile devices */}
        <FooterDisclosure title="رعاية العملاء" links={customerCareLinks} />

        {/* General for large devices */}
        <div className="hidden lg:block links mt-6">
          <h3 className="text-success font-semibold text-xl">روابط عامة</h3>
          <ul className="mt-4">
            <li className="mt-2">
              <Link href="/">الرئيسية</Link>
            </li>
            <li className="mt-2">
              <Link href="/contactus">اتصل بنا</Link>
            </li>
            <li className="mt-2">
              <Link href="/aboutus">من نحن</Link>
            </li>
            <li className="mt-2">
              <Link href="/policies">شروط الأستخدام</Link>
            </li>
            <li className="mt-2">
              <Link href="/delivery_policy">سياسة التوصيل </Link>
            </li>
          </ul>
        </div>
        {/* General for mobile devices */}
        <FooterDisclosure title="روابط عامة" links={generalLinks} />

        {/* Contact for mobile devices */}
        <FooterDisclosure title="اتصل بنا" settings={settings} />
        {/* Contact for large devices */}
        <div className="hidden lg:block contact-info mt-6">
          <h3 className="text-success font-semibold text-xl">اتصل بنا</h3>
          <ul className="mt-4">
            <li className="flex items-center mt-2">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path  fillRule="evenodd"  clipRule="evenodd" d="M1.48456 1.28993C1.1984 1.57641 0.936016 1.92781 0.766364 2.23381C0.553282 2.6078 0.39598 3.01792 0.301142 3.44431L0.251789 3.70194C-0.525969 7.64793 0.461777 11.1779 3.72244 14.4153C5.86183 16.5394 7.48412 17.4123 9.70541 17.731C10.0654 17.7826 10.4414 17.8214 10.8887 17.8545L11.8085 17.9104C12.3218 17.937 13.177 17.9796 13.469 17.9962C13.8535 18.0181 14.3622 17.9446 15.0459 17.7844L15.1495 17.7541C15.7463 17.5432 16.2913 17.2012 16.7476 16.7444C18.4175 15.0727 18.4175 12.3623 16.7476 10.6906L16.5988 10.5486C14.9846 9.0787 12.5161 9.06527 10.8868 10.5155L10.6937 10.6903L9.6613 11.7238C9.43506 11.9503 9.07884 11.981 8.81727 11.7965C8.27315 11.4128 6.82742 9.99777 6.47451 9.51552C6.28266 9.25337 6.31052 8.89031 6.54011 8.66056L7.44966 7.75057L7.52746 7.68727L7.64297 7.58023C7.66381 7.56016 7.68503 7.53933 7.70607 7.51827C9.4241 5.79836 9.4241 3.00984 7.70607 1.28993C5.98805 -0.429977 3.20259 -0.429977 1.48456 1.28993ZM2.88004 2.68694C3.82736 1.73858 5.36327 1.73858 6.31059 2.68694C7.25792 3.6353 7.25792 5.1729 6.31059 6.12126C6.25198 6.17993 6.19093 6.23522 6.1276 6.28704L5.14498 7.2632C4.22656 8.18226 4.11513 9.6345 4.88252 10.6831C5.36278 11.3394 6.96259 12.9052 7.68069 13.4116L7.81923 13.503C8.84988 14.1374 10.1911 13.9874 11.0568 13.1208L12.0112 12.1651L12.0243 12.1584L12.1162 12.0684C13.0169 11.1869 14.4602 11.1947 15.3521 12.0877C16.2513 12.9878 16.2513 14.4472 15.3521 15.3473L15.1987 15.4879C15.0402 15.6207 14.8665 15.7301 14.6814 15.8147L14.5321 15.8748L14.2784 15.9307L14.0105 15.9809C13.809 16.0146 13.663 16.0284 13.5811 16.0237L11.5773 15.9196L11.0464 15.8851L10.5859 15.8464C10.3701 15.8256 10.1735 15.8023 9.98536 15.7753C8.20707 15.5202 6.96435 14.8515 5.11215 13.0125C2.42085 10.3404 1.58666 7.57631 2.13656 4.36266L2.19408 4.05025C2.24621 3.73027 2.34276 3.45456 2.48632 3.20252C2.57373 3.04499 2.72574 2.84142 2.88004 2.68694Z" fill="white"/>
                </svg>
              </span>
                <a href={`tel:${ settings.phone}`} className='mr-6'>{ settings.phone}</a>
            </li>
            <li className="flex items-center mt-2">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path  fillRule="evenodd"  clipRule="evenodd" d="M5.00098 3.99902C3.34412 3.99902 2.00098 5.34217 2.00098 6.99902V16.999C2.00098 18.6559 3.34412 19.999 5.00098 19.999H19.001C20.6578 19.999 22.001 18.6559 22.001 16.999V6.99902C22.001 5.34217 20.6578 3.99902 19.001 3.99902H5.00098ZM4.82649 6.01419C4.88315 6.00422 4.94146 5.99902 5.00098 5.99902H19.001C19.0605 5.99902 19.1188 6.00422 19.1755 6.0142L12.001 10.7972L4.82649 6.01419ZM4.00098 7.86755V16.999C4.00098 17.5513 4.44869 17.999 5.00098 17.999H19.001C19.5533 17.999 20.001 17.5513 20.001 16.999V7.86757L12.5557 12.8311C12.2198 13.055 11.7822 13.055 11.4463 12.8311L4.00098 7.86755Z" fill="white"/>
                </svg>
              </span>
                <a href={`mailto:${ settings.email}`} className='mr-4'>{ settings.email}</a>
            </li>
            <li className="flex items-center mt-2">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
                    <path  fillRule="evenodd"  clipRule="evenodd" d="M7.00098 2.00098C4.23955 2.00098 2.00098 4.23955 2.00098 7.00098C2.00098 9.78888 3.61267 13.8683 7.00098 17.5563C10.3893 13.8683 12.001 9.78888 12.001 7.00098C12.001 4.23955 9.7624 2.00098 7.00098 2.00098ZM0.000976562 7.00098C0.000976562 3.13498 3.13498 0.000976562 7.00098 0.000976562C10.867 0.000976562 14.001 3.13498 14.001 7.00098C14.001 10.6532 11.8365 15.5796 7.70808 19.7081C7.31756 20.0986 6.68439 20.0986 6.29387 19.7081C2.16542 15.5796 0.000976562 10.6532 0.000976562 7.00098Z" fill="white"/>
                    <path  fillRule="evenodd"  clipRule="evenodd" d="M7.00098 8.00098C7.55326 8.00098 8.00098 7.55326 8.00098 7.00098C8.00098 6.44869 7.55326 6.00098 7.00098 6.00098C6.44869 6.00098 6.00098 6.44869 6.00098 7.00098C6.00098 7.55326 6.44869 8.00098 7.00098 8.00098ZM7.00098 10.001C8.65783 10.001 10.001 8.65783 10.001 7.00098C10.001 5.34412 8.65783 4.00098 7.00098 4.00098C5.34412 4.00098 4.00098 5.34412 4.00098 7.00098C4.00098 8.65783 5.34412 10.001 7.00098 10.001Z" fill="white"/>
                </svg>
              </span>
                <a href={`#`} className='mr-6'>{ settings.address}</a>
            </li>
          </ul>
          <div className="hidden lg:block socials mt-8 lg:mt-4">
            <ul className="flex items-center">
              {settings.social_medias.map((social: any, index: number) => {
                return (
                  <li className={index > 0 ? 'mr-6' : ''} key={index}>
                    <a href={social.url} className="border-2 border-success-500 rounded-md p-1 inline-block cursor-pointer text-success-500">
                      <Image
                        src={
                          process.env.NEXT_PUBLIC_SITE_URL +
                          '/storage/' +
                          social.icon
                        }
                        width="25"
                        height="25"
                        alt={'social-icon'}
                        className="fill-current"
                      />
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>

        <div className="block lg:hidden socials mt-8 lg:mt-4">
            <ul className="flex justify-center gap-[24px]">
              {settings.social_medias.map((social: any, index: number) => {
                return (
                  <li key={index}>
                    <a href={social.url} className='border-2 border-success-500 rounded-md p-1 inline-block cursor-pointer text-success-500'>
                      <Image
                        src={
                          process.env.NEXT_PUBLIC_SITE_URL +
                          '/storage/' +
                          social.icon
                        }
                        width="24"
                        height="24"
                        alt={'social-icon'}
                        className="fill-current"
                      />
                    </a>
                  </li>
                )
              })}
            </ul>
        </div>
      </div>
      <div className="footer-credits container-fluid pt-3 mt-4 mb-2 text-center font-light capitalize">
        <p>
          Copyright {new Date().getFullYear()}{' '}
          <a href="https://nazadv.com" className="font-semibold text-center">
            BASMTI
          </a>{' '}
          . All rights reserved
        </p>
      </div>
    </footer>
  )
}
